'use client';

import React from 'react';
import type { ReactNode } from 'react';
import { Label as AriaLabel, Group as AriaGroup } from 'react-aria-components';
import { cx } from '../../../utils/cx';

const SEMANTIC_NAME = 'RomaToggleGroup';

export interface ToggleGroupProps {
    title?: string;
    children: ReactNode;
    className?: string;
}

export const ToggleGroup = ({ title, children, className }: ToggleGroupProps) => {
    return (
        <AriaGroup className={cx(SEMANTIC_NAME, 'flex flex-col gap-md', className)} data-toggle-group>
            {title && <AriaLabel className="text-md font-medium text-primary select-none">{title}</AriaLabel>}
            <div className="flex flex-col gap-md">{children}</div>
        </AriaGroup>
    );
};

ToggleGroup.displayName = SEMANTIC_NAME;
